export const setDimensions = (width, height = width) => `
    width: ${width};
    height: ${height};
`;

export const toRem = (pxValue) => `${pxValue / 16}rem`;
